export default "__VITE_ASSET__7b16ea3d__"